"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.BillingGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var spinner_svg_1 = __importDefault(require("../../assets/spinner.svg"));
var ui_common_1 = require("@codametrix/ui-common");
var getBillingGroup = function (showProcessStatus, suppressedLinks, caseRuns) {
    if (showProcessStatus === void 0) { showProcessStatus = false; }
    if (!(caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.length)) {
        return false;
    }
    var suppressedSet = new Set(__spreadArray([], __read(suppressedLinks), false));
    var getMiniStatus = function (caseRun, idx) {
        var _a;
        var statusDisplay = ui_common_1.caseUtils.deriveStatus(caseRun);
        var description = (_a = caseRun.exam_description) !== null && _a !== void 0 ? _a : '';
        var clinicalId = "".concat(caseRun.primary_clinical_identifier.number, " (").concat(caseRun.primary_clinical_identifier.issuer, ")");
        var mainStatus = showProcessStatus
            ? statusDisplay.processStatus
            : statusDisplay.signifier;
        var styleClasses = [
            'related-group-item',
            'qa-related-group-item',
            statusDisplay.styleClass
        ];
        var inner = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "related-group-item-content" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "info-display" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "circle" }), mainStatus] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "descriptive-text ellipsify" }, { children: description })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "clinical-id sensitive-data" }, { children: ["#", clinicalId] }))] })));
        var itemClasses = 'qa-related-group-item-line related-group-item-line';
        return ((0, jsx_runtime_1.jsx)("li", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: suppressedSet.has(caseRun.case_id) ? ((0, jsx_runtime_1.jsx)("span", __assign({ className: itemClasses }, { children: inner }))) : ((0, jsx_runtime_1.jsx)("a", __assign({ className: itemClasses, href: "/cmx/cases/".concat(caseRun.case_id), "data-case-id": "".concat(caseRun.case_id), title: "".concat(description, " - ").concat(caseRun.process_status) }, { children: inner }))) }), "".concat(caseRun.process_instance_id, "-").concat(idx)));
    };
    var relatedStatuses = caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.map(getMiniStatus);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "relation-grouping" }, { children: (0, jsx_runtime_1.jsx)("ul", __assign({ className: "related-group" }, { children: relatedStatuses })) })));
};
var DEFAULT_PROPS = {
    cancelled: false,
    showLoading: false,
    isActive: false,
    showProcessStatus: false,
    suppressedLinks: [],
    viewOnly: false
};
var BillingGroup = function (_a) {
    var _b;
    var _c = _a.cancelled, cancelled = _c === void 0 ? false : _c, groupedCases = _a.groupedCases, _d = _a.isActive, isActive = _d === void 0 ? false : _d, _e = _a.showLoading, showLoading = _e === void 0 ? false : _e, _f = _a.showProcessStatus, showProcessStatus = _f === void 0 ? false : _f, _g = _a.suppressedLinks, suppressedLinks = _g === void 0 ? [] : _g, _h = _a.viewOnly, viewOnly = _h === void 0 ? false : _h, rest = __rest(_a, ["cancelled", "groupedCases", "isActive", "showLoading", "showProcessStatus", "suppressedLinks", "viewOnly"]);
    var caseRuns = (_b = groupedCases === null || groupedCases === void 0 ? void 0 : groupedCases.caseRuns) !== null && _b !== void 0 ? _b : [];
    var isStandalone = !(caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.length);
    var styleClasses = [
        'billing-group',
        {
            'bg-loaded': !showLoading,
            'bg-with-cases': !!(caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.length),
            'bg-empty': !showLoading && isStandalone,
            'bg-show-loading': showLoading,
            'case-cancelled': cancelled
        }
    ];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, rest, { children: [showLoading && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "loading-content" }, { children: (0, jsx_runtime_1.jsx)("img", { src: spinner_svg_1["default"], alt: "in progress", className: "spinner" }) }))), !(caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.length) && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "empty-content" }, { children: "There are no other related cases at this time." }))), !!(caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.length) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "billing-group-items" }, { children: getBillingGroup(showProcessStatus, suppressedLinks, caseRuns) })))] })));
};
exports.BillingGroup = BillingGroup;
BillingGroup.displayName = 'BillingGroup';
//# sourceMappingURL=billing-group.js.map